import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TemplateRulesService } from "../template-rules.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { CommonService } from "src/app/core/services/common.service";
import { TranslateService } from "@ngx-translate/core";
import { PKTemplateRule } from "../models/template-rules.model";

@Component({
  selector: "app-create-edit-templates-rules",
  templateUrl: "./create-edit-templates-rules.component.html",
  styleUrls: ["./create-edit-templates-rules.component.scss"],
})
export class CreateEditTemplatesRulesComponent implements OnInit {
  rulesTemplate;
  routing = RoutingConstants.rulesTemplatesRouting;
  operation: string;
  activedTemplates: [];
  ecuacionIsValid: boolean = false;
  reEcuacionToCompare: string;
  ecuacionIsValidToCompare: boolean;

  constructor(
    private templateRulesService: TemplateRulesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrAlertService: ToastrAlertService,
    private commonService: CommonService,
    private listValueService: ListValueService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
    this.getActivedTemplates();
    this.setDocumentSelected();
    this.operation = this.activatedRoute.data["_value"]["operation"];
  }

  setDocumentSelected() {
    let value = this.templateRulesService.getTypeOfDocumentSelected();
    this.rulesTemplate.patchValue({
      reReforma: value.tipoReforma,
      reTcertificado: value.tipoCertificado,
    });
  }

  getActivedTemplates() {
    this.listValueService.listaPlatillasActivas().subscribe(
      (data) => {
        this.activedTemplates = data;
        if (
          this.operation === "edicion" &&
          this.activatedRoute.snapshot.params.id
        ) {
          this.getTemplateRule();
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  initFormGroup() {
    this.rulesTemplate = new FormGroup({
      reDesc: new FormControl("", [Validators.maxLength(128)]),
      reEcuacion: new FormControl("", [
        Validators.required,
        Validators.maxLength(512),
      ]),
      reIndice: new FormControl(""),
      reMarcolegal: new FormControl("N"),
      rePlantilla: new FormControl("", [
        Validators.required,
        Validators.maxLength(32),
      ]),
      reReforma: new FormControl(""),
      reTcertificado: new FormControl(""),
    });
  }

  getTemplateRule() {
    let id: PKTemplateRule = JSON.parse(this.activatedRoute.snapshot.params.id);
    this.templateRulesService.getRuleTemplate(id).subscribe(
      (data) => {
        this.setValues(data);
        this.ecuacionIsValid = true;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  setValues(data) {
    let rePlantillaObject = this.activedTemplates.find(
      (item) => item["paId"] === data.rePlantilla
    );

    this.rulesTemplate.patchValue({
      reDesc: data.reDesc,
      reEcuacion: data.reEcuacion,
      rePlantilla: rePlantillaObject,
      reIndice: data.id.reIndice,
      reMarcolegal: data.id.reMarcolegal,
      reReforma: data.id.reReforma,
      reTcertificado: data.id.reTcertificado,
    });
  }

  onUpdate() {
    this.templateRulesService
      .updateRuleTemplate(this.rulesTemplate.value)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(
            data["mensaje"],
            this.routing.list
          );
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  onCreate() {
    this.templateRulesService
      .createRuleTemplate(this.rulesTemplate.value)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(
            data["mensaje"],
            this.routing.list
          );
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.rulesTemplate.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      let state = this.validateRuleTemplate();
      if (state) {
        this.templateRulesService
          .validateEcuacion(this.rulesTemplate.value.reEcuacion)
          .subscribe(
            (data) => {
              this.toastrAlertService.toastrSuccess(data.mensaje);
              this.formatToSave();
              if (this.operation === "edicion") {
                this.onUpdate();
              } else if (this.operation === "creacion") {
                this.onCreate();
              }
            },
            (err) => {
              this.toastrAlertService.toastrFail(err.error.mensaje);
            }
          );
      } else {
        let message = this.translateService.instant(
          "messages.activedTemplateWrongSelected"
        );
        this.toastrAlertService.toastrFail(message);
      }
    }
  }

  validateRuleTemplate() {
    let rePlantillaObject = this.activedTemplates.find(
      (item) => item["paId"] === this.rulesTemplate.value.rePlantilla["paId"]
    );
    return rePlantillaObject ? true : false;
  }

  formatToSave() {
    this.rulesTemplate.patchValue({
      rePlantilla: this.rulesTemplate.value.rePlantilla["paId"],
    });
  }

  valueSelector(value) {
    this.rulesTemplate.patchValue({
      rePlantilla: value.item,
    });
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  addToTextarea(character) {
    this.rulesTemplate.patchValue({
      reEcuacion: this.rulesTemplate.value.reEcuacion + "" + character,
    });
  }

  validateEcuacion() {
    this.templateRulesService
      .validateEcuacion(this.rulesTemplate.value.reEcuacion)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  changeEcuacion() {
    this.ecuacionIsValidToCompare = this.ecuacionIsValid;
    this.ecuacionIsValid = false;
    this.reEcuacionToCompare = this.rulesTemplate.value.reEcuacion;
  }

  chechIfHasChanged() {
    if (this.reEcuacionToCompare === this.rulesTemplate.value.reEcuacion) {
      this.ecuacionIsValid = this.ecuacionIsValidToCompare;
    }
  }
}
